import { useEffect, useRef } from 'react'

const POLL_INTERVAL_MS = 4 * 60 * 60 * 1000

async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return null
    const data = await res.json()
    return data.version ?? null
  } catch {
    return null
  }
}

export function useVersionCheck() {
  const currentVersion = useRef<string | null>(null)

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return

    fetchVersion().then((v) => {
      currentVersion.current = v
    })

    const check = async () => {
      const latest = await fetchVersion()
      if (
        latest &&
        currentVersion.current &&
        latest !== currentVersion.current
      ) {
        window.location.reload()
      }
    }

    const interval = setInterval(check, POLL_INTERVAL_MS)

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        check()
      }
    }

    document.addEventListener('visibilitychange', handleVisibility)

    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [])
}
